import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manifesting_ds_containers_by_type_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { containerTypeCategoriesId?: number, fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, Height?: number, Length?: number, Name?: string, Weight?: number, Width?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/Manifesting/datasources/ds_containers_by_type_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { containerTypeCategoriesId?: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Height?: number, Length?: number, Name?: string, Weight?: number, Width?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Manifesting/datasources/ds_containers_by_type_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { containerTypeCategoriesId?: number, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, Height?: number, Length?: number, Name?: string, Weight?: number, Width?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manifesting/datasources/ds_containers_by_type_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      containerTypeCategoriesId?: number, fullTextSearch?: string    }) {
      return false;
    }
}
